import styled from 'styled-components';
import { tokens } from '../../../design/tokens';

export const Container = styled.div`
  display: grid;
  grid-template-columns: minmax(260px, 340px) 1fr;
  grid-template-areas:
    'filters filters'
    'picker form';
  gap: 20px;
  width: 100%;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      'filters'
      'picker'
      'form';
  }
`;
export const FiltersRow = styled.div`
  grid-area: filters;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  width: 100%;
`;

export const PickerColumn = styled.div`
  grid-area: picker;
  min-width: 0;
`;

export const FormColumn = styled.div`
  grid-area: form;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  padding: 20px;
  background: ${tokens.color.cardCharcoal};
  border: 1px solid ${tokens.color.railGraphite};
  border-radius: ${tokens.radius.md};
`;

export const SectionTitle = styled.h3`
  margin: 0;
  color: ${tokens.color.textWhite};
  font-size: 1rem;
  font-weight: 600;
`;

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 14px;
  width: 100%;
`;

export const FullWidth = styled.div`
  grid-column: 1 / -1;
  width: 100%;
`;
